import { apiClient } from './apiClient';
import { Process, ProcessCreate, ProcessUpdate } from '../types/process';
import { NestedStateMachineService } from './nestedStateMachineService';

export class ProcessService {
  private static instance: ProcessService;
  private readonly baseUrl = '/processes';
  private readonly nestedStateMachineService: NestedStateMachineService;

  private constructor() {
    this.nestedStateMachineService = NestedStateMachineService.getInstance();
  }

  public static getInstance(): ProcessService {
    if (!ProcessService.instance) {
      ProcessService.instance = new ProcessService();
    }
    return ProcessService.instance;
  }

  async getProcesses(): Promise<Process[]> {
    const response = await apiClient.get<Process[]>(this.baseUrl);
    return response.data;
  }

  async getProcess(id: string): Promise<Process> {
    const response = await apiClient.get<Process>(`${this.baseUrl}/${id}`);
    return response.data;
  }

  async createProcess(process: ProcessCreate): Promise<Process> {
    const response = await apiClient.post<Process>(this.baseUrl, process);
    return response.data;
  }

  async updateProcess(id: string, process: ProcessUpdate): Promise<Process> {
    const response = await apiClient.put<Process>(`${this.baseUrl}/${id}`, process);
    return response.data;
  }

  async deleteProcess(id: string): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${id}`);
  }

  async getNestedStateMachine(processId: string) {
    return this.nestedStateMachineService.getNestedStateMachine(processId);
  }

  async validateNestedStateMachine(processId: string) {
    return this.nestedStateMachineService.validateNestedStateMachine(processId);
  }

  async executeNestedStateMachine(
    processId: string,
    currentState: string,
    parameters?: Record<string, unknown>
  ) {
    return this.nestedStateMachineService.executeNestedStateMachine(processId, {
      current_state: currentState,
      parameters: parameters || {},
    });
  }
}
